<template>
    <div class="page">
        <Headers></Headers>

        <div class="banner">

            <!-- 本页标题 -->
            <div class="banner_title">背景介绍</div>

            <!-- 内容 -->
            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">碳中和进程评级的目的<span class="btm_line"></span></div>
                    <div class="txt">气候变暖带来的种种自然灾害是人类必须面临的挑战，碳中和是全球应对气候变化的共同举措，也是全球各大经济体承担责任的方式。碳中和对企业的运营、服务、供应链管理、战略发展、投资方向等等提出了新的要求，因此，评估一家企业或者组织排放水平是否碳中和，对推进碳中和的贡献，成为评价企业可持续发展的重要维度，借此评价体系与评级，我们希望共同推动企业在碳中和方向做出更多行动。</div>
                </a-col>
                <a-col>
                    <img src="@/assets/img/t_img.png" class="img_box" alt="">
                </a-col>
            </a-row>

            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">关于碳中和进程评级系统<span class="btm_line"></span></div>
                    <div class="txt">碳中和进程评级是由 MVGX TECH、亚洲碳中和评测中心 (ACNAC)，根据ISO相关标准方法学共同推出，且经过 TÜV SÜD的国际性认证形成的评价体系，具有国际独立知识产权。该体系参考企业排放影响与减排贡献等因素，评估企业在多个维度上的碳中和运营表现给予综合评价得分，以反映企业在碳中和运营方面的贡献指数。该评级体系包括八个维度：直接排放、间接排放、直接减排贡献、间接减排贡献、零碳运营、绿色供应链、承诺与披露、零碳投资，每个维度满分100分，具有不同权重。碳中和进程评级体系将企业和同类行业同规模企业的全球数据进行比较，对企业碳中和表现进行评价认证，并最终根据企业表现计算综合得分和排名，评价结果由TÜV SÜD作出核证。该评估可帮助企业了解自身在行业中碳中和进程方面的表现，了解差异，制定相应改善策略，提升企业环境友好的管理水平，获得减碳收益并建立良好的社会形象。</div>
                </a-col>
                <a-col :span="9">
                    <!-- <img src="@/assets/img/cank.png" class="cank_box" alt=""> -->
                    <div class="charts">
                        <Echarts v-if="PdftStore.fromData.questionnaireInfo" :name="'page3echarts'"/>
                    </div>
                </a-col>
            </a-row>

            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">参评收益<span class="btm_line"></span></div>
                    <div class="txt">碳中和进程评估可以帮助企业了解自身的碳中和表现与行业领先水平的差距，从而降低风险。高评级的企业能够脱颖而出，更好地展现其环保友好的管理水平与承担更多社会责任的形象，有助于品牌建设。评级评估之后，企业能够更好地符合碳中和趋势下的政策要求，降低运营成本，并获得减碳收益。</div>
                </a-col>
            </a-row>

            <!-- <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">{{$t('page3.AboutTUVSUD')}}<span class="btm_line"></span></div>
                    <div class="txt">{{$t('page3.AboutTUVSUDTxt')}}</div>
                </a-col>
                <a-col :span="9">
                    <div class="mg_c">
                        <img src="@/assets/img/onelogo.png" class="tuvlogo_box" alt="">
                    </div>
                </a-col>
            </a-row> -->

            <!-- <div class="btm_banner">
                该报告由ACNAC出具并发布
            </div> -->
            <div class="logo_txt">
                <!-- <div>本报告由ACNAC委托</div>
                <img src="@/assets/img/min_tuv.png" class="img_min" alt="">
                <div>TÜV SÜD核证并发布</div> -->
            </div>

            <div class="flxed">01</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
export default {
    name: 'page3',
    components:{Headers,Echarts},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .banner_title{
            padding: 96px 0 40px 0;
            font-size: 72px;
            font-weight: bold;
            color: #013C89;
            line-height: 100px;
            border-bottom: 2px solid #013C89;
        }
        .mg_t{
            margin-top: 136px;
        }
        .t1{
            font-size: 32px;
            font-weight: bold;
            color: #333333;
            line-height: 45px;
        }
        .txt{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 42px;
            margin-top: 24px;
            text-align: justify;
        }
        .btm_line{
            display: inline-block;
            width: 36px;
            height: 4px;
            background: #0DC7F5;
            margin-left: 5px;
            transform: translateY(5px);
        }
        .img_box{
            width:440px;
            height: 270px;
            margin-left: 20px;
            margin-top: 15px;
        }
        .cank_box{
            width:388px;
            height: 363px;
        }
        .tuvlogo_box{
            width:195px;
            height: 195px;
            margin-left: 210px;
        }
        .mg_c{
            width: 100%;
        }
        .btm_banner{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            text-align: right;
            padding: 16px 0 0 0;
            border-top: 2px solid #013C89;
            margin-top: 105px;
        }
        .logo_txt{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            text-align: right;
            padding: 16px 0 0 0;
            justify-content: flex-end;
            border-top: 2px solid #013C89;
            margin-top: 280px;
            display: flex;
            align-items: center;
            .img_min{
                width: 20px;
                height: 20px;
                margin: 0 5px;
            }
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
    }
}
.charts{
    width: 440px;
    height: 440px;
    margin: 10px 0 0 50px;
}
</style>